import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "c-card-section__bg-media",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "c-card-section__inner" }
const _hoisted_4 = { class: "c-card-section__header" }
const _hoisted_5 = {
  key: 0,
  class: "c-card-section__cards"
}
const _hoisted_6 = {
  key: 0,
  class: "c-card-section__card-title"
}
const _hoisted_7 = ["innerHTML"]

import { computed } from 'vue';
import { RichText, Text as JssText } from '@sitecore-jss/sitecore-jss-vue';
import type { CardSectionCardFields, CardSectionProps } from '@/types/components/CardSection';
import type { ScItem } from '@/types/sitecore';
import utils from '@/utils';

interface NormalizedCard extends ScItem<CardSectionCardFields> {
  fields: CardSectionCardFields;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CardSection',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;
const fields = computed(() => props.fields);

const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'c-card-section'));
const rootStyle = computed(() => utils.overall?.baseComStyle?.(fields.value) || {});

const rawCards = computed<ScItem<CardSectionCardFields>[]>(() => {
  const cardItems = utils.sc.getFieldObj(fields.value, 'cards');
  return Array.isArray(cardItems) ? cardItems : [];
});

const cards = computed<NormalizedCard[]>(() =>
  rawCards.value.filter((card): card is NormalizedCard => Boolean(card.fields))
);

return (_ctx: any,_cache: any) => {
  const _component_AdaptiveImage = _resolveComponent("AdaptiveImage")!
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (fields.value)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(rootClass.value),
        style: _normalizeStyle(rootStyle.value),
        id: __props.rendering?.dataSource
      }, [
        (fields.value.backgroundImage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (fields.value.backgroundImage)
                ? (_openBlock(), _createBlock(_component_AdaptiveImage, {
                    key: 0,
                    class: "bg-img",
                    field: fields.value.backgroundImage,
                    show: true,
                    "enable-scroll-detection": false,
                    "show-image-redius": false
                  }, null, 8, ["field"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [2, 20],
          "mobile-default-grid": [1, 14]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("header", _hoisted_4, [
                _cache[0] || (_cache[0] = _createElementVNode("span", {
                  class: "c-card-section__mark",
                  "aria-hidden": "true"
                }, null, -1)),
                (fields.value.title?.value)
                  ? (_openBlock(), _createBlock(_unref(RichText), {
                      key: 0,
                      class: "c-card-section__title",
                      field: fields.value.title
                    }, null, 8, ["field"]))
                  : _createCommentVNode("", true)
              ]),
              (cards.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards.value, (card) => {
                      return (_openBlock(), _createElementBlock("article", {
                        key: card.id,
                        class: "c-card-section__card"
                      }, [
                        (card.fields.title?.value)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_6, [
                              _createElementVNode("strong", {
                                innerHTML: card.fields.title.value
                              }, null, 8, _hoisted_7)
                            ]))
                          : _createCommentVNode("", true),
                        (card.fields.description?.value)
                          ? (_openBlock(), _createBlock(_unref(RichText), {
                              key: 1,
                              class: "c-card-section__card-description",
                              field: card.fields.description
                            }, null, 8, ["field"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ], 14, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})